import { useRefreshToken } from "~/utils/refresh-token";

const { refreshToken } = useRefreshToken();

export const errorHandler = async (err: any, requestAxios?: any) => {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        break;
      case 401:
        // message = "未授权，请重新登录";
        // Cookie.remove(ACCESS_TOKEN);
        // Cookie.remove(REFRESH_TOKEN);
        // toLogin();
        break;
      case 403:
        // 刷新token
        await refreshToken();
        return requestAxios.request(err.response.config);
      case 404:
        break;
    }
  }
  return Promise.reject(err);
};
